<template>
  <form @submit.prevent="submitForm">
    <div class="form-control" :class="{invalid: !firstName.isValid}">
      <label for="firstname">First Name</label>
      <input type="text" id="fistname" v-model.trim="firstName.value" @blur="clearValidity('firstName')" />
      <p v-if="!firstName.isValid">The first name must not be empty.</p>
    </div>
    <div class="form-control" :class="{invalid: !lastName.isValid}">
      <label for="lastname">Last Name</label>
      <input type="text" id="lastname" v-model.trim="lastName.value" @blur="clearValidity('lastName')"/>
      <p v-if="!lastName.isValid">The last name must not be empty.</p>
    </div>
    <div class="form-control" :class="{invalid: !description.isValid}">
      <label for="description">Description</label>
      <textarea id="description" rows="5" v-model.trim="description.value" @blur="clearValidity('description')"/>
      <p v-if="!description.isValid">The description must not be empty.</p>
    </div>
    <div class="form-control" :class="{invalid: !rate.isValid}">
      <label for="rate">Hourly Rate </label>
      <input type="number" id="rate" v-model.number="rate.value" @blur="clearValidity('rate')"/>
      <p v-if="!rate.isValid">The rate must not be zero.</p>
    </div>
    <div class="form-control" :class="{invalid: !areas.isValid}">
      <h3>What are your areas of expertise?</h3>
      <div>
        <input type="checkbox" id="frontend" value="frontend" v-model="areas.value" @change="clearValidity('areas')"/>
        <label for="frontend">Frontend Development</label>
      </div>
      <div>
        <input type="checkbox" id="backend" value="backend" v-model="areas.value" @change="clearValidity('areas')"/>
        <label for="backend">Backend Development</label>
      </div>
      <div>
        <input type="checkbox" id="career" value="career" v-model="areas.value" @change="clearValidity('areas')"/>
        <label for="career">General Career Counselling</label>
      </div>
      <p v-if="!areas.isValid">You need to select at least one area of expertise</p>
    </div>
    <p v-if="!formIsValid">There are some incorrect values in the form. Please fill correctly and resubmit.</p>
    <base-button>Register</base-button>
  </form>
</template>

<script>
export default {
  emits: ["save-data"],
  data() {
    return {
      firstName: {
        value: '',
        isValid: true
      },
      lastName: {
        value: '',
        isValid: true
      },
      description: {
        value: '',
        isValid: true
      },
      rate: {
        value: null,
        isValid: true
      },
      areas: {
        value: [],
        isValid: true
      },
      formIsValid: true // initially true to not show the error messages above the submit button.
    };
  },
  methods: {
    clearValidity(inputName) {
      this[inputName].isValid = true;
    },
    validateForm() {
      // Initially set to true in case any of the values changed since the last validation.
      this.formIsValid = true;
      // Now it validates each data value separately
      if (this.firstName.value === '') {
        this.firstName.isValid = false;
        this.formIsValid = false;
      }
      if (this.lastName.value === '') {
        this.lastName.isValid = false;
        this.formIsValid = false;
      }
      if (this.description.value === '') {
        this.description.isValid = false;
        this.formIsValid = false;
      }
      if (!this.rate.value || this.rate.value < 0) {
        this.rate.isValid = false;
        this.formIsValid = false;
      }
      if (this.areas.value.length === 0) {
        this.areas.isValid = false;
        this.formIsValid = false;
      }
      
    },
    submitForm() {
      // starts with form validation to assess the value of formIsValid
      this.validateForm();

      if (this.formIsValid === false){
        return; // Ends the execution of submitForm if the validation fails.
      }
      const formData = {
        first: this.firstName.value,
        last: this.lastName.value,
        desc: this.description.value,
        rate: this.rate.value,
        areas: this.areas.value,
      };
      this.$emit("save-data", formData);
    },
  },
};
</script>

<style scoped>
.form-control {
  margin: 0.5rem 0;
}

label {
  font-weight: bold;
  display: block;
  margin-bottom: 0.5rem;
}

input[type="checkbox"] + label {
  font-weight: normal;
  display: inline;
  margin: 0 0 0 0.5rem;
}

input,
textarea {
  display: block;
  width: 100%;
  border: 1px solid #ccc;
  font: inherit;
}

input:focus,
textarea:focus {
  background-color: #f0e6fd;
  outline: none;
  border-color: #3d008d;
}

input[type="checkbox"] {
  display: inline;
  width: auto;
  border: none;
}

input[type="checkbox"]:focus {
  outline: #3d008d solid 1px;
}

h3 {
  margin: 0.5rem 0;
  font-size: 1rem;
}

.invalid label {
  color: red;
}

.invalid input,
.invalid textarea {
  border: 1px solid red;
}

p {
  color: red;
}
</style>
